import type { Technology } from '../../domain/technology';
import { BASE_API_URL, HttpClient } from '../../services/HttpClient';

const BASE_URL = `${BASE_API_URL}/technographics`;

export const technologiesApi = {
  getTechnologies: async (domain: string, signal?: AbortSignal) =>
    HttpClient.get<Technology[]>(`${BASE_URL}?domain=${domain}`, { signal }),
};
